import React from 'react';
import { useMeetings } from '../../../../../../data/hooks/meeting/useMeetings';
import CommonTabContent from '../CommonTabContent';

function AllMeetings(props) {
    const { eventId } = props,
        meetings = useMeetings(eventId);

    return <CommonTabContent eventId={eventId} meetings={meetings} />;
}

export default AllMeetings;
